<!-- 开始聊天组件 -->
<template>
  <div>
    <div class="chat-card">
      <div class="chat-title">情绪日记</div>
      <textarea :disabled="!isCanEdit" v-model="textareaVal" class="textarea" name="textarea" cols="28" rows="8" placeholder="点击输入今天发生了什么"></textarea>
      <button v-if="isCanEdit" class="confirm-btn" @click="confirmFn">确定</button>
    </div>
    <!-- <div class="send-time">09月01日  16:29</div> -->
  </div>
</template>

<script>

export default {
  name: 'ChatTextarea',
  props: {
    cardData: {
      type: Object,
      default() {
        return null;
      }
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    }
  },
  components: {
  },
  data() {
    return {
      textareaVal: ''
    };
  },
  created() {
  },
  mounted() {
    if(this.nextData?.step_data?.survey?.qstList[0].answer.val) {
      let useData = this.nextData.step_data.survey.qstList[0].answer.val;
      this.textareaVal = useData;
    }
  },
  methods: {
    confirmFn() {
      let useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: this.cardData.step_type,
                answer: {
                  val: this.textareaVal
                },
              },
            ],
          },
        },
      };
      this.$emit('confirmFn', useData);
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 342px;
  height: 226px;
  border-radius: 12px 12px 12px 0px;
  padding: 12px 15px 0;
  background: #E8E3FC;
  box-sizing: border-box;
  .chat-title {
    width: 100%;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 23px;
    color: rgba(59, 59, 59, 1);
  }
  .textarea {
    width: 303px;
    height: 144px;
    padding: 16px;
    box-sizing: border-box;
    margin-top: 5px;
    margin-left: -2px;
    line-height: 15px;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0px;
    border: none;
    border-radius: 7px;
    background: rgba(255, 255, 255, 1);
    display: block;
    &::placeholder {
      font-weight: 300;
      color: rgba(0, 0, 0, 0.4);
    }
  }

  .confirm-btn {
    width: 76px;
    height: 25px;
    border-radius: 12px;
    background: #AD7EFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0.23px;
    color: #fff;
    border: none;
    margin: 9px auto 0;
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9D9FA3;
  margin-top: 4px;
}
</style>
